// SelectingConfiguringAction.js
import React from 'react';
import { Box, Grid, Typography, List, ListItem } from '@mui/material';
import '../Docs.css';

/**
 * Lets users choose how PostSheet will deliver the records pulled
 * from the data-source. After the choice, the app jumps to the
 * corresponding “Compose” screen.
 */
export default function SelectingConfiguringAction() {
  return (
    <Box sx={{ p: 2 }}>
      <Typography variant="h2" gutterBottom>
        Selecting&nbsp;&amp;&nbsp;Configuring an Action
      </Typography>

        {/* —— Left column : explanation —— */}
     
          <Typography paragraph>
            Pick one of the delivery channels below. You can add multiple
            actions to the same campaign later if you need multichannel
            outreach.
          </Typography>

          <List
            className="steps-list"
            sx={{ pl: 3, listStyleType: 'disc' }}
          >
            <ListItem>
              <strong>Email</strong> — sends from your connected&nbsp;Gmail.
            </ListItem>
            <ListItem>
              <strong>WhatsApp</strong> — requires an authenticated&nbsp;Twilio
              account.
            </ListItem>
            <ListItem>
              <strong>SMS</strong> — also powered by&nbsp;Twilio.
            </ListItem>
          </List>

          <Typography paragraph sx={{ mt: 2 }}>
            Once you click <em>Select</em>, PostSheet opens the channel-specific
            composer where you write the message, map merge-fields and set
            scheduling options.
          </Typography>
            <img
            src="../../static/docs/SelectAction.jpg"
            alt="Action selection dialog"
            className="step"
          />
      
    </Box>
  );
}
